const apiUrl = process.env.REACT_APP_API_URL;

export const PostCaza = async (formData: FormData) => {
    try {
        const response = await fetch(`${apiUrl}:8061/jutge/caza`, {
            method: 'POST',
            body: formData,
        });
        if (response.ok) {
            try {
                const data = await response.json();
                return { ok: true, id: data?.id };
            } catch {
                return { ok: true };
            }
        }
        return { ok: false };
    } catch (error) {
        console.error('Error creating/updating Caza:', error);
        return { ok: false };
    }
};
